import { render } from "./addView.vue?vue&type=template&id=3592350c&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./addView.vue?vue&type=style&index=1&id=3592350c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3592350c"]])

export default __exports__